// LongSignInBlock.tsx · v12.10.30 (#2234 "Exception allowed: Longer timeout" - the last block of a person's account) · 2026-11-03 · VoiceSpectrum AI
//
// v12.10.30 (#2234, Tushar 11/2 SETTLED): the long sign-in VoiceSpectrum Support gave a person is NOT a pill on the Users list. It is the last
// block of that person's account (Your account, and the person's drawer in Users), after every other section - seen only when the account
// is opened and scrolled to the bottom. Who gave it, when, why and how many hours. Nothing to change here: only Support Ops gives / takes it.
import type { UserRow } from '../../lib/securityApi';

export function LongSignInBlock({ user, self }: { user: UserRow | null | undefined; self?: boolean }) {
  const g = user?.longSignIn;
  if (!g?.on) return null;
  const when = g.at ? new Date(g.at).toLocaleString(undefined, { month: 'short', day: 'numeric', year: 'numeric', hour: 'numeric', minute: '2-digit' }) : null;
  return (
    <div className="sc-dw-sec" data-testid="long-signin-block">
      <h5>Exception allowed: Longer timeout</h5>
      <p className="sc-sub" style={{ margin: '0 0 6px' }}>
        {self ? 'You stay' : 'This person stays'} signed in for up to {g.hours} hours without activity instead of the practice’s own timeout -
        only on a browser {self ? 'you' : 'they'} trusted (“Don’t ask again on this browser” at the 2-step). Every other browser keeps the practice’s timeout.
      </p>
      <div className="sc-sub" style={{ margin: 0 }}>
        Given by <b>{g.by || 'VoiceSpectrum Support'}</b>{when ? <> · {when}</> : null}{g.reason ? <> · {g.reason}</> : null}
      </div>
    </div>
  );
}
